import { SearchMode } from "helpers/api";
import { useLocalStorageState } from "hooks/useLocalStorageState/useLocalStorageState";
import { useCallback } from "react";

const DEEP_SEARCH_WAIT_TIME_MS = 60 * 1000; // 60 seconds

/**
 * This hook is used to check if the user can create a new thread interaction.
 * It is used to prevent users from creating too many deep search interactions in a short period of time.
 * @returns A function that checks if the user can create a new thread interaction.
 */
export function useCanCreateNewThreadInteraction() {
  const [lastDeepSearchTime, setLastDeepSearchTime] = useLocalStorageState<
    number | null
  >("lastDeepSearchTime", null);

  const checkCanCreate = useCallback(
    (searchMode: SearchMode): [boolean, string] => {
      // Check deep search rate limiting for PRO_RESEARCH
      if (searchMode === SearchMode.PRO_RESEARCH) {
        if (lastDeepSearchTime) {
          const currentTime = Date.now();
          const timeDiff = currentTime - lastDeepSearchTime;

          if (timeDiff < DEEP_SEARCH_WAIT_TIME_MS) {
            return [
              false,
              `Please wait a minute before using Deep Search again.`,
            ];
          }
        }

        // Update the last deep search time
        setLastDeepSearchTime(Date.now());
      }

      return [true, ""];
    },
    [lastDeepSearchTime, setLastDeepSearchTime]
  );

  return checkCanCreate;
}
